import axios from 'axios';
import { AlertService } from "app/services/alertService"
const url = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: url,
  headers: {
    'Content-Type': 'application/json'
  }
});
axiosInstance.interceptors.response.use(

  (response) => response,
  (error) => {

    if (error.response?.data?.errors) {

      AlertService.error(JSON.stringify(error.response.data.errors), { keepAfterRouteChange: true, autoClose: false });
      return Promise.reject((error.response.data.errors) || 'Something went wrong!');

    }
    else if (error.response?.data?.message) {
      console.log(error.request.responseURL.toString().includes('tms'));
      if (!error.request.responseURL.toString().includes('tms'))
        AlertService.error(JSON.stringify(error.response.data.message), { keepAfterRouteChange: true, autoClose: false });
      return Promise.reject((error.response.data.message) || 'Something went wrong!');

    }
    else {
      AlertService.error(error.response.data.message, { keepAfterRouteChange: true, autoClose: false });
      return Promise.reject((error.response && error.response.data && error.response.data.message) || 'Something went wrong!');


    }


  }
);



export default axiosInstance;
